import { useState, useEffect } from "react";
import Confetti from "react-confetti";
import { useDispatch } from "react-redux";

const CustomConfetti = ()=> {
 // const [showConfetti, setShowConfetti] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const dispatch = useDispatch();

  // Update size on resize so confetti always covers viewport
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => {
        window.removeEventListener("resize", handleResize);
       
    }
  }, []);

  return  <Confetti
          width={windowSize.width}
          height={windowSize.height}
          recycle={false} // stops after one burst
          numberOfPieces={500}
         // onConfettiComplete={()=>  dispatch(updateProjectState({showConfetti: false,}))}
        />
 
}

export default CustomConfetti;
